<template>
    <div>
        <div v-if="availableSegments.length != 1">
            <h1>Select a form</h1>
            <div>
                <button type="button" class="btn btn-outline-secondary cancel dfNavButton mx-auto" @click.prevent="setSegment(segment)" v-for="segment in availableSegments">
                    {{ segment.definition.settings.displayLabel }}
                    <!-- TODO -->
                </button>
            </div>
        </div>
        <div v-else>
            <template v-if="mustLoginAndNotLoggedIn">
                <p>This cannot be started until you log in.</p>
                <button class="btn btn-primary cancel dfNavButton mx-auto" @click="forceLogin">Log In</button>
            </template>
            <form @submit.prevent="selfAssignSegmentAuto" v-else>
                <template v-if="adminReview">
                    <p v-if="activeSegment.isAssignedToOtherUser">This is currently assigned to another user. You must steal it by reassigning it to yourself if you wish to complete it.</p>
                    <p v-else>This cannot be started until it is assigned to yourself.</p>
                </template>
                <p v-else-if="verifyItems.length > 0">This cannot be started until you verify your identity.</p>
                <p v-else><!-- TODO when does this case happen? -->You must start this before you can continue.</p>
                <div v-if="verifyFailureMessages.length > 0">
                    <ul>
                        <li v-for="message in verifyFailureMessages">{{ message }}</li>
                    </ul>
                </div>
                <div class="form-group" v-for="(verifyItem, index) in verifyItems">
                    <label :for="'verify' + index">{{ verifyItem.prompt }}</label>
                    <input class="form-control" type="text" :id="'verify' + index" v-model="verifyData[verifyItem.prompt || '']" />
                </div>
                <button type="button" class="btn btn-primary cancel dfNavButton mx-auto" @click.prevent="selfAssignSegment(segment)" v-for="segment in availableSegments">
                    <template v-if="adminReview">{{ activeSegment.isAssignedToOtherUser ? "Reassign" : "Assign" }} to myself</template>
                    <template v-else>Continue</template>
                </button>
            </form>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, computed, inject } from "vue";
import { usePageStore } from "../pageState/store";
import { useMainStore } from "@/mainStore";
import { forceLoginInjectKey } from "../Page.3.vue.InjectKeys";
import { computedAsync } from "@vueuse/core";
import StateFormDef from "../elements/StateFormDef";
export default defineComponent({
    setup() {
        const mainStore = useMainStore();
        const pageStore = usePageStore();
        const verifyData = ref({} as Record<string, string | undefined>);
        const verifyFailureMessages = ref([] as string[]);

        const forceLogin = inject(forceLoginInjectKey)!;

        const availableSegments = computed(() => pageStore.availableSegments!);
        const adminReview = computed(() => pageStore.adminReview);
        const mustLoginAndNotLoggedIn = computedAsync(async () => {
            return activeSegment.value.definition.settings.mustLogin && !(await mainStore.isLoggedInPromise);
        });
        const activeSegment = computed(() => {
            return availableSegments.value![0];
        });
        const verifyItems = computed(() => {
            return activeSegment.value.definition.settings.verifyItems ?? [];
        });
        const selfAssignSegmentAuto = async () => {
            const availableSegmentsV = availableSegments.value!;
            if (availableSegmentsV.length == 1) {
                await selfAssignSegment(availableSegmentsV[0]);
            }
        };
        const setSegment = (segment: StateFormDef) => {
            pageStore.segment = segment.id!;
        };
        const selfAssignSegment = async (segment: StateFormDef) => {
            verifyFailureMessages.value = await pageStore.selfAssignSegment({ segment: segment.id!, verifyData: verifyData.value });
        };

        return {
            availableSegments,
            adminReview,
            forceLogin,
            selfAssignSegment,
            setSegment,
            mustLoginAndNotLoggedIn,
            selfAssignSegmentAuto,
            activeSegment,
            verifyItems,
            verifyData,
            verifyFailureMessages,
        };
    },
});
</script>
